module.exports = __webpack_public_path__ + "static/media/dashboard-illustration.3fb73ebb.png";